import React from 'react'
import {Col, Row, Descriptions, Table} from "antd";
import gokhanLogo from '../../../logo/gokhanLogo.jpeg'
import armaledLogo from '../../../logo/armaled_logo.jpeg'
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import config from "../../../config";
import '../../../css/print.css'

const logoStyle = {
    width: '100%'
};

class OfferPrint extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            subTotals: {
                "EUR": [],
                "USD": [],
                "TRY": []
            },
            showDiscount: false,
            columns: [
                {
                    title: '#',
                    key: 'index',
                    render: (text, record, index) => index + 1
                },
                {
                    title: 'ÜRÜN KODU',
                    render: (t, r) => r.stock.code
                },
                {
                    title: 'AÇIKLAMA',
                    render: (t, r) => r.stock.description
                },
                {
                    title: 'MARKA',
                    render: (t, r) => r.stock.brand.code
                },
                {
                    title: 'MİKTAR',
                    render: (t, r) => r.amount.toFixed(2)
                },
                {
                    title: 'BİRİM',
                    render: (t, r) => r.stock.unit
                },
                {
                    title: 'BİRİM FİYAT',
                    render: (t, r) => `${(r.hasOwnProperty('linePrice') ? r.linePrice.toLocaleString() : r.stock.price.toLocaleString())} ${r.selectedCurrency}`
                },
                {
                    title: 'TOPLAM',
                    render: (t, r) => r.lineTotal.toLocaleString()
                },
                {
                    title: 'TERMİN',
                    render: (t, r) => r.deadline
                }

            ],
            discountColumns: [
                {
                    title: '#',
                    key: 'index',
                    render: (text, record, index) => index + 1
                },
                {
                    title: 'ÜRÜN KODU',
                    render: (t, r) => r.stock.code
                },
                {
                    title: 'AÇIKLAMA',
                    render: (t, r) => r.stock.description
                },
                {
                    title: 'MARKA',
                    render: (t, r) => r.stock.brand.code
                },
                {
                    title: 'MİKTAR',
                    render: (t, r) => r.amount.toFixed(2)
                },
                {
                    title: 'BİRİM',
                    render: (t, r) => r.stock.unit
                },
                {
                    title: 'BİRİM FİYAT',
                    render: (t, r) => `${(r.linePrice ? r.linePrice : r.stock.price).toFixed(2)} ${r.selectedCurrency}`
                },
                {
                    title: 'İskonto %',
                    render: (t, r) => r.discount
                },
                {
                    title: 'İskonto Hariç Toplam',
                    render: (t, r) => new Intl.NumberFormat().format(r.amount * (r.linePrice ? r.linePrice : r.stock.price))
                },
                {
                    title: 'TOPLAM',
                    render: (t, r) => new Intl.NumberFormat().format(r.lineTotal)
                },
                {
                    title: 'TERMİN',
                    render: (t, r) => r.deadline
                }
            ]
        }
    }


    componentDidMount() {
        let hasSecondDiscount = false;
        this.props.offer.bid.contentOfBidList.map((item, index) => {

            if (item.discount) {
                this.setState({showDiscount: true});
                if (item.discount2) {
                    hasSecondDiscount = true;
                }
            }

            if (this.state.subTotals.hasOwnProperty(this.props.offer.bid.contentOfBidList[index].selectedCurrency)) {

                this.setState(oldState => {
                    oldState.subTotals[this.props.offer.bid.contentOfBidList[index].selectedCurrency].push(item.lineTotal);
                    return oldState;
                })
            } else {
                this.setState(oldState => {
                    oldState.subTotals[this.props.offer.bid.contentOfBidList[index].selectedCurrency] = [item.lineTotal];
                    return oldState;
                })
            }
        })

        const secondDiscount = {
            title: 'İskonto 2',
            render: (t, r) => r.discount2
        };
        this.state.discountColumns.splice(8, 0, secondDiscount);
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <Row justify={"space-between"}>
                        <Col span={7}>
                            <img src={config.currentTenant() === 'gokhan' ? gokhanLogo : armaledLogo} alt=""
                                 style={logoStyle}/>
                        </Col>
                        <Col span={14}>
                            <Descriptions size={'small'} bordered>
                                <Descriptions.Item span={3}
                                                   label={'Firma'}>{this.props.offer.bid.customer.name}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'Teklif No'}>{this.props.offer.bid.bidNumber}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'Tarih'}>{userDateFormatter(this.props.offer.bid.dateOfBid)}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'İlgili'}>{this.props.offer.bid.representative}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'Kimden'}>{`${this.props.offer.bid.employee.name} ${this.props.offer.bid.employee.surname}`}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'Telefon'}>{this.props.offer.bid.employee.phoneNumber}</Descriptions.Item>
                                <Descriptions.Item 
                                                   label={'E-mail'}>{this.props.offer.bid.employee.username}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <div style={{margin: '64px 0 16px 0'}} className={'font-bold'}>
                        <Row justify={"center"}>
                            <Col span={3}>
                                <h5>TEKLİF</h5>
                            </Col>
                        </Row>
                    </div>
                    <div style={{margin: '32px 0'}}>
                        <Row>
                            <Col span={24}>
                                <Table rowKey={'id'}
                                       className={'offer-print-table'}
                                       columns={this.state.showDiscount ? this.state.discountColumns : this.state.columns}
                                       dataSource={this.props.offer.bid.contentOfBidList} pagination={false}/>
                            </Col>
                        </Row>
                    </div>
                    <Row justify={"space-between"} style={{marginTop: '64px'}}>
                        <Col span={12}>
                            <Descriptions bordered size={'middle'}>
                                <Descriptions.Item span={3} label={'KDV'} className={'font-bold'}>Birim Fiyatlara KDV
                                    Dahil
                                    Değildir</Descriptions.Item>
                                <Descriptions.Item span={3}
                                                   className={'font-bold'}
                                                   label={'KUR'}>{this.props.offer.bid.exchangeRate}</Descriptions.Item>
                                <Descriptions.Item span={3}
                                                   className={'font-bold'}
                                                   label={'TESLİMAT'}>{this.props.offer.bid.delivery}</Descriptions.Item>
                                <Descriptions.Item span={3}
                                                   className={'font-bold'}
                                                   label={'ÖDEME'}>{this.props.offer.bid.payment}</Descriptions.Item>
                                <Descriptions.Item span={3}
                                                   className={'font-bold'}
                                                   label={'NOT'}>{this.props.offer.bid.note}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                        <Col span={6}>
                            <Descriptions bordered size={'middle'}>
                                {
                                    Object.keys(this.state.subTotals).map(key => {
                                        let item = this.state.subTotals[key]

                                        if (item.length) {
                                            let currencySum = item.reduce((a, b) => a + b)
                                            return (
                                                <React.Fragment key={`${key}-currency`}>
                                                    <Descriptions.Item
                                                        span={3}
                                                        className={'font-bold'}
                                                        key={`${key}-price`}
                                                        label={`${key}`}
                                                    >
                                                        {new Intl.NumberFormat().format(currencySum)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item
                                                        span={3}
                                                        className={'font-bold'}
                                                        key={`${key}-taxed-price`}
                                                        label={` KDV(${key}/%20)`}
                                                    >
                                                        {
                                                            new Intl.NumberFormat()
                                                                .format(currencySum * config.commonTax)
                                                        }
                                                    </Descriptions.Item>
                                                    <Descriptions.Item
                                                        span={3}
                                                        className={'font-bold'}
                                                        key={`${key}-total`}
                                                        label={`TOPLAM (${key})`}
                                                    >
                                                        {
                                                            new Intl.NumberFormat()
                                                                .format(currencySum * config.totalWithCommonTax)
                                                        }
                                                    </Descriptions.Item>
                                                </React.Fragment>
                                            )
                                        }
                                    })
                                }
                            </Descriptions>
                        </Col>
                    </Row>
                    <div className={'bank-info'} style={{margin: '64px 0 32px'}}>
                        <h5 className={'font-bold'}>Banka Hesap Bilgilerimiz</h5>
                        {
                            config.currentTenant() === 'gokhan'
                                ? <Row justify={'start'}>
                                    <Col span={12}>
                                        <p><span className={'font-bold'}>AKBANK TL</span>: TR57 0004 6001 5688 8000 0035 36
                                        </p>
                                        <p><span className={'font-bold'}>AKBANK EUR</span>: TR81 0004 6001 5603 6000 0261 55
                                        </p>
                                        <p><span className={'font-bold'}>AKBANK USD</span>: TR32 0004 6001 5600 1000 0270 63
                                        </p>
                                        <p><span className={'font-bold'}>DENİZBANK TL</span>: TR52 0013 4000 0042 1882 7000
                                            01</p>
                                    </Col>
                                    <Col span={12}>
                                        <p><span className={'font-bold'}>GARANTİ TL</span>: TR91 0006 2000 0670 0006 2009 28
                                        </p>
                                        <p><span className={'font-bold'}>YAPI KREDI TL</span>: TR35 0006 7010 0000 0010 2320
                                            95</p>
                                        <p><span className={'font-bold'}>Türkiye İŞ BANKASI TL</span>: TR52 0006 4000 0011
                                            0210 6192 47</p>
                                    </Col>
                                </Row>
                                : <Row justify={'start'}>
                                    {
                                        config.armaBankAccounts.map((item, index) => {
                                            return (
                                                <Col span={8} key={`bank-${index}-col`}>
                                                    <p key={`bank-${index}`}><span className={'font-bold'}>{item.name}</span>: {item.key}</p>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default OfferPrint